<template>
  <div class="g-stripe">
    <dialog-warp v-model="isCreditcard">
      <div class="u-stripe">
        <div class="creditcard-input">
          <div id="credit-card-element"></div>
        </div>
        <div class="btn u-stripe-btn" @click="onStripeSetup">
          {{ this.$t("confirm.confirmpay") }}
        </div>
      </div>
    </dialog-warp>
  </div>
</template>

<script>
import stripeMixin from "./index"
import DialogWarp from "../common/dialog_warp"
import {
  STRIPE_PAYORDER,
  STRIPE_PREAUTH_OF_CONFIRM,
  STRIPE_PREAUTH_AUTO_CONFIRM
} from "../../apis/payment"

export default {
  props: {
    payCode: {
      type: String,
      default: ""
    },
    payType: {
      type: String,
      default: ""
    },
    payPrice: {},
    outTradNo: {
      type: String,
      default: ""
    },
    publicKey: {
      type: String,
      default: ""
    }
  },
  mixins: [stripeMixin],
  components: {
    DialogWarp
  },
  data() {
    return {
      isCreditcard: false,
      payMode: {}
    }
  },
  computed: {
    i18n() {
      return this.$t("confirm")
    }
  },
  methods: {
    // stripe 支付
    async onCreditcard(payMode = {}, callback) {
      this.payMode = payMode
      let url = `${STRIPE_PREAUTH_OF_CONFIRM}/${this.payCode}`
      let query = {
        amount: this.payPrice,
        paymentId: payMode.pId
      }
      if (this.payType == "FK") {
        url = STRIPE_PAYORDER
        query = {
          couponNo: null,
          outTradeNo: this.outTradNo,
          paymentId: payMode.pId
        }
      }
      let headers = {}
      this.$loading(true)
      await this.$Request("post", url, query, headers)
        .then((resp) => {
          if (resp.data) {
            // if (this.payType === "FK") {
            //   this.stripePayConfirm("", query.outTradeNo, callback)
            //   return
            // }
            this.creditStripeElement(resp.data, "#credit-card-element", () => {
              this.isCreditcard = true
            })
          }
        })
        .catch((err) => {
          console.warn(" onCreditcard ~ err:", err)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onCreditcard(payMode)
          })
        })
      this.$loading(false)
    },
    // stripe 支付
    onStripeSetup() {
      // 支付事件回调
      const payCall = ({ error }) => {
        this.$loading(false)
        if (error && error.message) {
          this.$toast(error.message)
        }
      }
      const _location = window.location
      const _pathQuery = _location.href.split("#")[1].includes("?") ? "&" : "?"
      let _query = {
        payType: this.payType,
        paymentId: this.payMode.pId
      }
      if (_query.payType === "FK") {
        _query.tradeNo = this.outTradNo
      }
      _query = new URLSearchParams(_query).toString()
      // 支付参数
      let payQuery = {
        elements: this.creditPayCard,
        confirmParams: { return_url: `${_location.href + _pathQuery + _query}` }
      }
      this.$loading(true)
      const { paymentWay } = this.$route.query
      if (paymentWay === "PAYMENT_CARD") {
        payQuery.confirmParams.return_url = `${_location.origin}#/confirm?qrcode=${this.cabinet.qrcode}&paymentId=${this.payMode.pId}&pmid=${this.creditOrder.paymentId}`
        window.stripe.confirmSetup(payQuery).then((res) => payCall(res))
      } else {
        window.stripe.confirmPayment(payQuery).then((res) => payCall(res))
      }
    },
    /**
     * stripe 支付确认
     * paymentIntent outTradeNo
     */
    stripePayConfirm(paymentIntent = "", outTradeNo = "", callback) {
      let query = {
        tradeNo: paymentIntent,
        outTradeNo: outTradeNo
      }
      query = new URLSearchParams(query).toString()
      let url = `${STRIPE_PREAUTH_AUTO_CONFIRM}?${query}`
      this.$Request("get", url, {})
        .then((resp = {}) => {
          callback && callback(resp)
        })
        .catch((err) => {
          this.$loading(false)
          console.log(err)
        })
    }
  },
  mounted() {
    this.loadStripeScript(this.publicKey)
  },
  deactivated() {
    console.log("stripe 5555")
  },
  destroyed() {
    console.log("stripe 22222")
  }
}
</script>

<style lang="less" scoped>
.g-stripe {
  // position: fixed;
  // bottom: 0;
  // left: 0;
  // right: 0;
  position: relative;
  z-index: 910;
}
.u-stripe {
  width: 100vw;
  padding: 32px 0;
  box-sizing: border-box;
  background: #fff;
  border-top-left-radius: 60px;
  border-top-right-radius: 60px;
  .creditcard-input {
    min-height: 240px;
    margin: 48px 48px;
    padding: 20px;
    border-radius: 20px;
    border: 1px solid #e4e7ed;
  }
  &-btn {
    margin: 0 48px 24px;
  }
}
</style>
